import { functions } from '@/functions';

export const htype_functions = {
    data: function () {
        return {
            htypes :[],
            htypes_loaded:false,
        };
    },
    mixins: [functions],

    methods: {

        /*
         *   Список типов объектов отдыха
         */

        loadHtypes: function (onSuccess=null, param=null) {
            if (!this.isHtypesLoaded()) {
                this.htypes_loaded = false;
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/type')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.htypes = response.payload;
                    this.htypes_loaded = true;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetHtypes: function () {
            this.htypes = [];
            return this;
        },

        isHtypesLoaded: function () {
            return (this.htypes !== null) && this.htypes.length && this.htypes_loaded;
        },

    },

};



